@use "stylesheets/utility/variables";

.wrapper {
  margin: 40px auto;
  max-width: 450px;

  @media screen and (min-width: variables.$laptop) {
    margin: 180px auto 0;
  }
}
